import { useRouter } from 'vue-router';

interface TeacherModuleI {
  name: string;
  path: string;
}

const teacherModules: TeacherModuleI[] = [
  { name: '用户管理', path: '/Teacher/userManager' },
  { name: '案例分析', path: '/Teacher/caseAnalysis' },
  { name: '实验管理', path: '/Teacher/experimentManager' },
  { name: '实验报告', path: '/Teacher/reportManager' },
  { name: '自定义案例', path: '/Teacher/customCase' },
  { name: '应急资源库', path: '' },
];

class TeacherModule implements TeacherModuleI {
  name: string

  path: string

  constructor(option: TeacherModuleI) {
    this.name = option.name;
    this.path = option.path;
  }
}

class TeacherModules {
  public list: TeacherModule[]

  private router = useRouter()

  constructor() {
    this.list = teacherModules.map((item) => new TeacherModule(item));
  }

  public click(path: string) {
    console.log(path);
    this.router.push(path);
    console.log(this.router.getRoutes());
  }
}

export default TeacherModules;
